import { firebaseDB, API_BASE, firebaseAuth } from '@/config/firebaseConfig'
import axios from 'axios'

const state = {
  shopId: null,
  shopIds: [],
  shopDetails: [],
  shopAdminDetails: [],
  isShopLoading: true,
  logos: []
}

const mutations = {
  'ADD_URL_LOGO' (state, url) {
    state.logos.push({ url: url })
  },
  'CLEAR_SHOP' (state) {
    state.shopId = null
    state.shopDetails = []
    state.logos = []
    state.isShopLoading = true
  },
  'SET_SHOP_ID' (state, id) {
    state.shopId = id
  },
  'SET_SHOP_IDS' (state, ids) {
    state.shopIds = ids
  },
  'SET_SHOP_LOADING' (state, ref) {
    state.isShopLoading = ref
  },
  'UPDATE_SHOP_DETAILS' (state, shopDetails) {
    state.shopDetails = shopDetails
    state.isShopLoading = false
  },
  'UPDATE_SHOP_ADMIN_DETAILS' (state, shopDetails) {
    state.shopAdminDetails = shopDetails
    state.isShopLoading = false
  },
  'UPDATE_SHOP_LOGO_GALLERY' (state, logos) {
    state.logos = logos
  }
}

const actions = {
  setShopLoading ({ commit }) {
    commit('SET_SHOP_LOADING', true)
  },
  initializeShop ({ commit, getters, dispatch, state }, shopId) {
    commit('SET_SHOP_ID', shopId)
    dispatch('bindOrders', shopId)
    dispatch('getProductList')
    dispatch('getCategoryList')
    dispatch('getProductGallery')
    dispatch('getLogosGallery')
    dispatch('getShopDetails')
    dispatch('getShopAdminDetails')
  },
  async getShops ({ commit, getters, dispatch }) {
    const result = await firebaseDB().ref('users/' + getters.currentUser.uid + '/stores').once('value')
    const stores = result.val()
    const shops = []
    if (stores !== null) {
      Object.keys(stores).forEach((key) => {
        if (stores[key]) {
          shops.push(key)
        }
      })
      commit('SET_SHOP_IDS', shops)
      dispatch('initializeShop', shops[0])
    } else {
      commit('SET_SHOP_LOADING', false)
    }
  },
  async getLogosGallery ({ commit, getters }) {
    return firebaseDB().ref(`storeAdmin/${getters.shopId}/logos`).once('value', logos => {
      if (logos.exists() && logos.val().length) {
        commit('UPDATE_SHOP_LOGO_GALLERY', logos.val())
      }
    })
  },
  updateShopDetails ({ commit, getters }, details) {
    console.log(details)
    const shopRef = firebaseDB().ref('stores/' + getters.shopId)
    commit('UPDATE_SHOP_DETAILS', details)
    return shopRef.child('details').set(details)
  },
  updateShopAdminDetails ({ commit, getters }, details) {
    console.log(details)
    const shopRef = firebaseDB().ref('storeAdmin/' + getters.shopId)
    commit('UPDATE_SHOP_ADMIN_DETAILS', details)
    return shopRef.set(details)
  },
  async getShopDetails ({ commit, getters }) {
    console.log(getters.shopId)
    const shopRef = firebaseDB().ref('stores/' + getters.shopId)
    return shopRef.child('details').once('value', shop => {
      commit('UPDATE_SHOP_DETAILS', shop.val())
    })
  },
  async getShopAdminDetails ({ commit, getters }) {
    const shopRef = firebaseDB().ref('storeAdmin/' + getters.shopId)
    return shopRef.once('value', shop => {
      commit('UPDATE_SHOP_ADMIN_DETAILS', shop.val())
    })
  },
  async createNewStore ({ commit, dispatch }, details) {
    const token = await firebaseAuth().currentUser.getIdToken(true)
    const result = await axios.post(API_BASE + 'users-addStore', { store: details.domain }, {
      headers: {
        Authorization: token
      }
    })
    if (result) {
      return firebaseDB().ref(`stores/${details.domain}/details/`).set(details).then(() => {
        commit('UPDATE_SHOP_DETAILS', details)
        dispatch('getShops')
      })
    }
  },
  async addDriver ({ getters }, details) {
    const token = await firebaseAuth().currentUser.getIdToken(true)
    const result = await axios.post(API_BASE + 'stores-addDriver', { store: getters.shopId, email: details.email }, {
      headers: {
        Authorization: token
      }
    })
    console.log('result', result)
  }
}

const getters = {
  shopId: state => state.shopId,
  shopDetails: state => state.shopDetails,
  isShopLoading: state => state.isShopLoading,
  logos: state => state.logos,
  shopIds: state => state.shopIds,
  shopAdminDetails: state => state.shopAdminDetails
}

export default {
  state,
  mutations,
  actions,
  getters
}
